// extracted by mini-css-extract-plugin
module.exports = {"container":"two-column-layout_container_1UInj","left":"two-column-layout_left_1Gore","right":"two-column-layout_right_124Za"};